export const fmt = (n) => {
  const num = Number(n || 0);
  return num.toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// quantity (adet) — no forced decimals; shows up to 3 for fractional units
export const qty = (n) => {
  const num = Number(n || 0);
  return num.toLocaleString("tr-TR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
};

export const RATES = { RON: 1, EUR: 4.97, USD: 4.55 };
export const toRon = (n, currency = "RON") => Number(n || 0) * (RATES[currency] || 1);

export const money = (n, currency = "RON") => {
  const suffix = { RON: "lei", EUR: "EUR", USD: "USD" }[currency] || currency || "lei";
  return `${fmt(n)} ${suffix}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "-";
  }
};

export const daysUntil = (iso) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const d = new Date(iso);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - now) / (1000 * 60 * 60 * 24));
};
